// This file is automatically generated. Do not edit manually.

import { PurchaseOrderProjectView } from "src/api/generated/erp/db/types/tables/purchaseOrderProjectView";
import { CreatePurchaseOrderRequest } from "src/api/generated/erp/purchase/purchaseOrder/service/createPurchaseOrderRequest";
import { makeAxiosRequest } from "src/api/utils/apiClient";

export namespace PurchaseOrderProjectsApi {
	export async function getPurchaseOrdersForProject(args: {
		projectId: number;
	}): Promise<Array<PurchaseOrderProjectView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseOrder/projects/getPurchaseOrdersForProject",
			method: "POST",
			data: {
				projectId: args.projectId,
			},
		});
		return response as Array<PurchaseOrderProjectView>;
	}

	export async function getProjectsForPurchaseOrder(args: {
		purchaseOrderId: number;
	}): Promise<Array<PurchaseOrderProjectView>> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseOrder/projects/getProjectsForPurchaseOrder",
			method: "POST",
			data: {
				purchaseOrderId: args.purchaseOrderId,
			},
		});
		return response as Array<PurchaseOrderProjectView>;
	}

	export async function connectPurchaseOrderToProject(args: {
		purchaseOrderId: number;
		projectId: number;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseOrder/projects/connectPurchaseOrderToProject",
			method: "POST",
			data: {
				purchaseOrderId: args.purchaseOrderId,
				projectId: args.projectId,
			},
		});
		return response as number;
	}

	export async function disconnectPurchaseOrderFromProject(args: { purchaseOrderProjectId: number }): Promise<void> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseOrder/projects/disconnectPurchaseOrderFromProject",
			method: "POST",
			data: {
				purchaseOrderProjectId: args.purchaseOrderProjectId,
			},
		});
		return response as void;
	}

	export async function createPurchaseOrderForProject(args: {
		request: CreatePurchaseOrderRequest;
		projectId: number;
	}): Promise<number> {
		const response = await makeAxiosRequest({
			url: "/api/ext/erp/purchase/purchaseOrder/projects/createPurchaseOrderForProject",
			method: "POST",
			data: {
				request: args.request,
				projectId: args.projectId,
			},
		});
		return response as number;
	}
}
